export function safeColor(value?: string): string | undefined {
  if (!value) {
    return undefined;
  }

  if (typeof CSS === 'undefined') {
    return value;
  }

  if (!CSS.supports('color', value)) {
    return undefined;
  }

  return value;
}
